import { useEffect } from 'react';
import { useBrowser } from '../services/BrowserService';

export const useWindowEvent = <K extends keyof WindowEventMap>(
  eventName: K,
  callback?: (ev: WindowEventMap[K]) => void,
  passive?: boolean,
) => {
  const { window } = useBrowser();

  useEffect(() => {
    if (callback) {
      window?.addEventListener(eventName, callback, { passive });
      return () => window?.removeEventListener(eventName, callback);
    }

    return undefined;
  }, [callback, eventName, passive, window]);
};
